import axios from 'axios';
import service from './service';

const baseUrl = process.env.REACT_APP_API_BASE_URL || 'https://api-dev.thehive.schooladvisor.co.za/api/v1';

export const createAbortController = () => {
    return new AbortController();
};

export const UpdateTaskFile = (data: any, signal: any) => {
    return service.post(`tenders/${data.ids.tender_id}/tasks/${data.ids.task_id}`, data.data, { signal });
};

export const AwardSupplier = (data: any, signal: any) => {
    return service.post(`tenders/${data.ids.tender_id}/suppliers/${data.ids.supplier_id}/shortlist`, data.data, {
        signal
    });
};

export const createDocument = (data: any, signal: any) => {
    return service.post(`/tenders/${data.ids.tenderId}/tasks`, data.data, { signal });
};

export const uploadFileKikOff = (data: any, signal: any) => {
    return service.post(
        `/tenders/${data.tender_id}/tasks/${data?.task_id}/kick-off-questionnaire/upload-file?step=${data?.step}`,
        data.data,
        {
            signal
        }
    );
};

export const uploadFileKickOffPreview = (data: any, signal: any) => {
    const stepQuery = data?.step != null ? `?step=${data.step}` : '';
    return service.post(
        `/admin/tenders/expense-areas/${data.expense_area_id}/forms/kick-off-questionnaire/preview/upload-file${stepQuery}`,
        data.data,
        { signal }
    );
};

export const uploadDocuments = (data: any, signal: any) => {
    return service.post(`/tenders/${data.ids.tender_id}/tasks/${data?.ids?.task_id}?_method=PUT`, data.data, {
        signal
    });
};

export const declineTask = (data: any, signal: any) => {
    return service.post(`/tenders/${data.ids.tenderId}/tasks/${data.ids.taskId}/decline`, data.data, { signal });
};

export const downloadFileFunc = (data: any) => {
    return axios({
        method: 'get',
        url: `${baseUrl}/tenders/${data.tenderId}/tasks/${data.taskId}/files/${data.fileId}/download`,
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authUser') || '{}')?.authToken}`,
            'Content-Type': 'application/json'
        }
    });
};

export const downloadCapabilityProfile = (tenderId: number) => {
    return axios({
        method: 'get',
        url: `${baseUrl}/tenders/${tenderId}/suppliers/generate-capability-profile`,
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authUser') || '{}')?.authToken}`,
            Accept: 'application/pdf'
        }
    });
};

export const downloadProfileSummary = (tenderId: number) => {
    return axios({
        method: 'get',
        url: `${baseUrl}/tenders/${tenderId}/suppliers/generate-profile-summary`,
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authUser') || '{}')?.authToken}`,
            Accept: 'application/pdf'
        }
    });
};

export const downloadSolutionGuide = (tenderId: number) => {
    return axios({
        method: 'get',
        url: `${baseUrl}/tenders/${tenderId}/suppliers/generate-solution-guide`,
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authUser') || '{}')?.authToken}`,
            Accept: 'application/pdf'
        }
    });
};

export const downloadTPA = (signature: string) => {
    return axios({
        method: 'get',
        url: `${baseUrl}/supplier-companies/tender-registration/download-tpa${signature}`,
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authUser') || '{}')?.authToken}`,
            Accept: 'application/pdf'
        }
    });
};

export const downloadDocumentBySignature = (signature: string) => {
    return axios({
        method: 'get',
        url: `${baseUrl}/file-manager/download`,
        params: { signature },
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authUser') || '{}')?.authToken}`,
            Accept: 'application/pdf,application/octet-stream,*/*'
        }
    });
};
export const downloadExecutiveSummary = (tenderId: number) => {
    return axios({
        method: 'get',
        url: `${baseUrl}/tenders/${tenderId}/suppliers/generate-executive-summary`,
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authUser') || '{}')?.authToken}`,
            Accept: 'application/pdf'
        }
    });
};

export const downloadBidConditions = (tenderId: number) => {
    return axios({
        method: 'get',
        url: `${baseUrl}/tenders/${tenderId}/suppliers/generate-bid-conditions`,
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authUser') || '{}')?.authToken}`,
            Accept: 'application/pdf'
        }
    });
};

export const downloadMatchmakingReportPdf = (tenderId: number) => {
    return axios({
        method: 'get',
        url: `${baseUrl}/tenders/${tenderId}/suppliers/generate-matchmaking-report`,
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authUser') || '{}')?.authToken}`,
            Accept: 'application/pdf'
        }
    });
};

export const downloadSingleFileFunc = (uuid: string) => {
    return axios({
        method: 'get',
        url: `${baseUrl}/file-manager/download-single/${uuid}`,
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authUser') || '{}')?.authToken}`,
            'Content-Type': 'application/json'
        }
    });
};
